import { normaliseDateRange } from '@packages/rate-plans/utils/currentSubscription';

import clock from '@plugins/dayjs';

/**
 * Whether a subscription can be cancelled (future-dated scheduled change only).
 * @param {object|null|undefined} subscription
 * @param {string|null} [asOf] YYYY-MM-DD in Europe/London
 * @returns {boolean}
 */
export function isSubscriptionCancellable(subscription, asOf = null) {
    if (!subscription || typeof subscription !== 'object') {
        return false;
    }

    const range = normaliseDateRange(subscription.date_range);

    if (!range?.start) {
        return false;
    }

    const effectiveDate = asOf || clock().tz('Europe/London').format('YYYY-MM-DD');

    return range.start > effectiveDate;
}

export default isSubscriptionCancellable;
